<template>
  <div>
    <div class="outgoing-detail" v-if="details != null">
      <div class="card print" id="printed-element">
        <!-- HEADER PERUSAHAAN -->
        <div class="company-header">
          <div class="logo">
            <img src="/assets/images/logo.png" alt="mode_logo" />
          </div>
          <div class="company-info">
            <h4 class="header-title"><b>MODE FASHION GROUP</b></h4>
            <h6 class="header-subtitle">Jl.Laksana No 68 ABC, Medan</h6>
            <h6 class="header-subtitle">Telp. (061) 6643780</h6>
          </div>
          <div class="outlet-code">
            <h1>
              <b>{{ details.summary.outlet_code }}</b>
            </h1>
          </div>
        </div>

        <div class="border-header"></div>

        <!-- TITLE -->
        <div class="header-container">
          <h4 class="title"><b>BON MUTASI KELUAR GUDANG</b></h4>
        </div>

        <!-- INFO -->
        <div class="info-row">
          <div class="left">
            <p><span>Nomor Bon</span>: {{ details.summary.doc_number }}</p>
            <p>
              <span>Tanggal Bon</span>:
              {{ moment(details.summary.doc_date).format('DD-MM-YYYY') }}
            </p>
            <p><span>Toko Tujuan</span>: {{ details.summary.outlet_name }}</p>
          </div>
        </div>

        <!-- TABLE -->
        <div class="table-container">
          <table class="detail-bon">
            <thead>
              <tr>
                <th rowspan="2">No</th>
                <th rowspan="2">Kode Barang</th>
                <th rowspan="2">Kode Kategori</th>
                <th rowspan="2">Kode Supplier</th>
                <th rowspan="2">Nama Barang</th>
                <th rowspan="2">Disc %</th>
                <th rowspan="2">Harga (Rp.)</th>
                <th rowspan="2">Jumlah</th>
                <th rowspan="2">Total (Rp.)</th>
              </tr>
            </thead>
            <tbody>
              <tr
                v-for="(item, k) in outlet_inbounds_detail"
                :key="k"
                class="table-data-style"
              >
                <td class="text-center">{{ k + 1 }}</td>
                <td>{{ item.item_code }}</td>
                <td>{{ item.category_code }}</td>
                <td>{{ item.supplier_code }}</td>
                <td class="text-left">{{ item.item_name }}</td>
                <td class="text-center">{{ item.discount }}%</td>
                <td class="text-right">{{ item.price | currency }}</td>
                <td class="text-center">{{ item.qty }}</td>
                <td class="text-right">{{ item.total | currency }}</td>
              </tr>
              <tr class="total-row">
                <td colspan="7" class="text-right"><b>Total:</b></td>
                <td class="text-center">
                  <b>{{ details.summary.total_qty }}</b>
                </td>
                <td class="text-right">
                  <b>{{ details.summary.total_price | currency }}</b>
                </td>
              </tr>
            </tbody>
          </table>
        </div>

        <!-- FOOTER -->
        <div class="footer">
          <div class="signature-grid">
            <div class="signature-item">
              <div>Bagian Gudang</div>
              <div class="signature-line"></div>
            </div>
            <div class="signature-item">
              <div>Bagian Transport</div>
              <div class="signature-line"></div>
            </div>
            <div class="signature-item">
              <div>Bagian Toko</div>
              <div class="signature-line"></div>
            </div>
            <div class="signature-item">
              <div>Bagian Komputer</div>
              <div class="signature-line"></div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
var moment = require('moment')

export default {
  props: {
    detail: {
      type: Object,
      required: true
    }
  },

  data() {
    return {
      details: this.$props.detail,
      outlet_inbounds_detail: null,
      moment: moment,
      loading: true,
      products: null,
      expandedRows: [],
      confirmDialog: false,
      ModeLogo: undefined,
      rowIndex: 0,
      mutation_code: null,
      hasil: [],
      isDataReady: false
    }
  },

  async mounted() {
    try {
      await this.buildDetail()
      this.isDataReady = true

      // Add event listener for afterprint
      window.addEventListener('afterprint', this.handleAfterPrint)

      // Wait for next tick and then print
      this.$nextTick(() => {
        setTimeout(() => {
          window.print()
        }, 1000) // Increased delay to ensure content is rendered
      })
    } catch (error) {
      console.error('Error in mounted:', error)
      this.$toast.add({
        severity: 'error',
        summary: 'Error',
        detail: 'Failed to load data',
        life: 3000
      })
    }
  },

  beforeDestroy() {
    // Clean up event listener
    window.removeEventListener('afterprint', this.handleAfterPrint)
  },

  methods: {
    handleAfterPrint() {
      window.history.back()
    },

    buildDetail() {
      try {
        this.outlet_inbounds_detail = this.$props.detail.outlet_inbounds
        this.splitLength()
      } catch (error) {
        console.error('Error building detail:', error)
        throw error
      }
    },

    splitLength() {
      try {
        if (
          this.outlet_inbounds_detail &&
          this.outlet_inbounds_detail.length > 0
        ) {
          for (
            let i = 0;
            i < Math.ceil(this.outlet_inbounds_detail.length / 15);
            i++
          ) {
            this.hasil[i] = []
            for (let j = 0; j < 15; j++) {
              if (this.outlet_inbounds_detail[this.rowIndex]) {
                this.hasil[i][j] = this.outlet_inbounds_detail[this.rowIndex]
                this.rowIndex++
              }
            }
          }
        } else {
          console.warn('No outlet inbounds data available')
        }
      } catch (error) {
        console.error('Error splitting length:', error)
        throw error
      }
    }
  }
}
</script>

<style scoped lang="scss">
.outgoing-detail {
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto,
    'Helvetica Neue', Arial, sans-serif;
  width: 100%;
  margin: 0 auto;
  box-sizing: border-box;
  overflow: hidden;
}

.card {
  background: #ffffff;
  border-radius: 6px;
  box-shadow: 0 2px 1px -1px rgba(0, 0, 0, 0.2), 0 1px 1px 0 rgba(0, 0, 0, 0.14),
    0 1px 3px 0 rgba(0, 0, 0, 0.12);
  padding: 1.5rem;
}

.company-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 1rem;
}

.logo {
  width: 50px;
  img {
    width: 100%;
    height: auto;
  }
}

.company-info {
  flex: 1;
  margin-left: 1rem;
}

.header-title {
  font-size: 15px;
  line-height: 1.2;
  margin: 0;
}

.header-subtitle {
  font-size: 13px;
  line-height: 1.2;
  margin: 2px 0;
  color: #666;
}

.outlet-code {
  text-align: right;
  h1 {
    font-size: 24px;
    margin: 0;
  }
}

.border-header {
  border-top: 2px solid #000;
  width: 100%;
  margin: 1rem 0;
}

.header-container {
  text-align: center;
  margin-bottom: 1.5rem;
}

.title {
  font-size: 16px;
  margin: 0;
}

.info-row {
  margin-bottom: 1.5rem;
}

.left {
  p {
    margin: 4px 0;
    display: flex;
    span {
      width: 120px;
      font-weight: 500;
    }
  }
}

.table-container {
  width: 100%;
  overflow-x: auto;
  margin-bottom: 1.5rem;
}

.detail-bon {
  width: 100%;
  border-collapse: collapse;
  font-size: 12px;

  th,
  td {
    border: 1px solid #000;
    padding: 8px;
    text-align: center;
  }

  th {
    background-color: #f8f9fa;
    font-weight: 600;
  }

  .text-left {
    text-align: left;
  }

  .text-right {
    text-align: right;
  }

  .text-center {
    text-align: center;
  }

  .table-data-style {
    &:nth-child(even) {
      background-color: #f8f9fa;
    }
  }

  .total-row {
    font-weight: 600;
    background-color: #f8f9fa;
  }
}

.footer {
  margin-top: 2rem;
}

.signature-grid {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 1rem;
  margin-top: 3rem;
}

.signature-item {
  text-align: center;
}

.signature-line {
  border-top: 1px solid #000;
  width: 80%;
  margin: 2rem auto 0;
}

@media print {
  .outgoing-detail {
    margin: 0;
    padding: 0;
  }

  .card {
    box-shadow: none;
    padding: 0;
  }

  .detail-bon {
    th {
      background-color: #f8f9fa !important;
      -webkit-print-color-adjust: exact !important;
      print-color-adjust: exact !important;
    }

    .table-data-style:nth-child(even) {
      background-color: #f8f9fa !important;
      -webkit-print-color-adjust: exact !important;
      print-color-adjust: exact !important;
    }

    .total-row {
      background-color: #f8f9fa !important;
      -webkit-print-color-adjust: exact !important;
      print-color-adjust: exact !important;
    }
  }

  .print {
    page-break-after: always;
  }

  .print:last-child {
    page-break-after: auto;
  }
}
</style>
